import { useNavigate } from "react-router-dom";
import Button from "../../component/Button";
import { useEffect, useState } from "react";

import "./faq.css";
import { AxiosInstance } from "../../@api/api";
import { useResponsiveMobile } from "../../hooks/useResponsiveMobile";
import { setDescription } from "../../seo/seo";
type FaqItem = {
  question: string;
  answer: string;
};

const FAQ = () => {
  const navigate = useNavigate();
  const isMobile = useResponsiveMobile(900);
  //  API로 받아오는 FAQ 리스트 (개수 미정)
  const [faqs, setFaqs] = useState<FaqItem[]>([]);

  //  여러 개 동시 오픈: index들을 Set으로 관리
  const [openSet, setOpenSet] = useState<Set<number>>(new Set());
  const [appDownOn, setAppDownOn] = useState(false);
  const getFAQ = async () => {
    try {
      const result = await AxiosInstance.post("/api/v1/getFaqList", {});

      setFaqs(result.data.data.list);
    } catch (error) {
      console.error("getFaq Error", error);
    }
  };

  useEffect(() => {
    getFAQ();
  }, []);

  //  faqs 길이가 바뀌면(재호출 등) openSet이 범위를 벗어날 수 있으니 정리
  useEffect(() => {
    setOpenSet((prev) => {
      const next = new Set<number>();
      prev.forEach((idx) => {
        if (idx >= 0 && idx < faqs.length) next.add(idx);
      });
      return next;
    });
  }, [faqs.length]);

  const toggle = (idx: number) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx);
      else next.add(idx);
      return next;
    });
  };

  useEffect(() => {
    document.title = "품 : Poom | 자주 묻는 질문";
    setDescription(
      "통합 정산 서비스 이용 방법부터 요금제까지, 품(POOM)에 대해 궁금하신 점을 쉽고 빠르게 확인해보세요",
    );
  }, []);

  return (
    <div className="w-full flex flex-col gap-[40px] md:gap-[160px] justify-between">
      <div className="flex flex-col gap-[40px] md:gap-[160px]">
        <section className="w-full flex flex-col pt-6 md:pt-3 justify-center items-center px-6">
          <div
            className="
          w-full md:max-w-[1600px]
          rounded-[24px]
          aspect-[16/5] md:aspect-[16/3.6]
          min-h-[170px] max-h-[360px]
          flex justify-center items-center
          overflow-hidden
        "
            style={{
              backgroundImage: isMobile
                ? "url('/assets/images/faq/bg_mobile.png')"
                : "url('/assets/images/faq/bg.png')",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "top center",
            }}
          >
            <span className="text-[#000] font-bold text-[20px] md:text-display3 text-center">
              FAQ
              <br />
              자주 묻는 질문
            </span>
          </div>
        </section>

        <div className="flex w-full justify-center items-center">
          <section className="w-full flex justify-center md:px-[120px]">
            <div className="flex flex-col md:flex-col lg:flex-row md:items-stretch gap-12 w-full items-center md:max-w-[1440px] md:justify-between">
              {isMobile ? (
                <div className="flex flex-col items-center gap-6">
                  <img
                    src="/assets/images/faq/speaker.png"
                    alt="speaker"
                    width={151}
                    height="auto"
                  />
                  <h1 className="font-bold text-display3_1">자주 묻는 질문</h1>
                </div>
              ) : (
                <div className="flex flex-col justify-between md:justify-center md:items-center lg:justify-between md:gap-6 lg:items-start">
                  <h1 className="font-bold text-display">자주 묻는 질문</h1>
                  <img src="/assets/images/faq/speaker.png" alt="speaker" width={363} />
                </div>
              )}

              <div className="flex flex-col gap-6 md:gap-8 lg:min-w-[700px] px-6 md:px-0 w-full">
                {faqs.map((item, idx) => {
                  const isOpen = openSet.has(idx);

                  return (
                    <div
                      key={idx} //  id 없으므로 index key
                      className="gradient-border-box flex rounded-[12px] flex-col w-full lg:max-w-[700px] self-end"
                    >
                      {/*  질문 영역(클릭하면 토글) */}
                      <button
                        type="button"
                        onClick={() => toggle(idx)}
                        className="flex rounded-[12px] flex-row justify-between items-center p-4 md:px-8 md:py-[32px] w-full md:gap-[50px] text-left"
                      >
                        <span className="font-normal text-[16px] md:text-heading1">
                          {item.question}
                        </span>

                        <img
                          src={
                            isOpen
                              ? "/assets/images/icon/minus.png"
                              : "/assets/images/icon/plus.png"
                          }
                          alt={isOpen ? "minus" : "plus"}
                          className="cursor-pointer shrink-0 w-[clamp(20px,3.2vw,40px)] h-[clamp(20px,3.2vw,40px)]"
                        />
                      </button>

                      {/*  답변 영역(애니메이션 없이 단순 표시/숨김) */}
                      {isOpen && (
                        <div className="md:px-8 md:py-8 px-4 py-4 border-t-[1px] border-t-[#DDE0E6]">
                          <div className="faq-answer">
                            <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
                <div className="gradient-border-box flex rounded-[12px] flex-col w-full lg:max-w-[700px] self-end">
                  {/*  질문 영역(클릭하면 토글) */}
                  <button
                    type="button"
                    onClick={() => setAppDownOn(!appDownOn)}
                    className="flex rounded-[12px] flex-row justify-between items-center p-4 md:px-8 md:py-[38px] w-full md:gap-[50px] text-left"
                  >
                    <span className="font-normal text-[16px] md:text-heading1">
                      품 앱은 어떻게 다운로드 하나요?
                    </span>

                    <img
                      src={
                        appDownOn ? "/assets/images/icon/minus.png" : "/assets/images/icon/plus.png"
                      }
                      alt={appDownOn ? "minus" : "plus"}
                      className="cursor-pointer shrink-0 w-[clamp(20px,3.2vw,40px)] h-[clamp(20px,3.2vw,40px)]"
                    />
                  </button>

                  {/*  답변 영역(애니메이션 없이 단순 표시/숨김) */}
                  {appDownOn && (
                    <div className="px-8 py-[38px] border-t-[1px] border-t-[#DDE0E6] flex flex-col gap-6">
                      <span className="text-[12px] md:text-[18px] text-[#4d4f58] font-bold">
                        아래 링크를 클릭하여 앱을 다운로드 해보세요
                      </span>
                      <div className="flex flex-col md:flex-row gap-3">
                        <div
                          className="flex items-center flex-row gap-3 p-4 rounded-lg border-[1px] border-[#DDE0E6] md:w-[246px] cursor-pointer"
                          onClick={() => {
                            window.open(
                              "https://play.google.com/store/apps/details?id=com.wiezon.poombar&pcampaignid=web_share",
                            );
                          }}
                        >
                          <img
                            src="/assets/images/icon/google.png"
                            alt="google"
                            className="w-6 h-6"
                          />
                          <span className="text-[12px] md:text-[18px]">
                            구글 플레이스토어로 이동
                          </span>
                        </div>
                        <div
                          className="items-center flex flex-row gap-3 p-4 rounded-lg border-[1px] border-[#DDE0E6] md:w-[246px] cursor-pointer"
                          onClick={() => {
                            window.open(
                              "https://apps.apple.com/kr/app/%ED%92%88-%EA%B0%80%EB%A7%B9%EC%A0%90/id6449830182",
                            );
                          }}
                        >
                          <img src="/assets/images/icon/ios.png" alt="ios" className="w-6 h-6" />
                          <span className="text-[12px] md:text-[18px]">앱스토어로 이동</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <section
        className="flex h-auto w-full flex-col md:py-[80px] py-[120px] justify-center items-center gap-20"
        style={{
          backgroundImage: isMobile
            ? "url('/assets/images/faq/gradient_mobile.png')"
            : "url('/assets/images/faq/gradient.png')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: isMobile ? "top center" : "center",
          backgroundSize: "cover",
        }}
      >
        <div className="flex flex-col gap-8 items-center w-full md:px-4 px-6">
          <div className="flex flex-col gap-3 md:gap-6">
            <span className="font-bold text-[36px] md:text-display text-center">
              기타 문의사항이 {isMobile && <br />} 있나요?
            </span>
            <span className="font-normal text-heading1_2 text-center text-[#4D4F58]">
              1:1상담으로 편하게 {isMobile && <br />}질문해보세요
            </span>
          </div>

          <Button
            onClick={() => navigate("/help-center")}
            size="sm"
            className="bg-[#000] rounded-full px-8 md:h-[80px] h-[48px] w-fit md:text-[20px] text-[16px]"
          >
            질문하러 가기 →
          </Button>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
